import { ROLE_SUPERADMIN, ROLE_ADMIN } from '../../constants/roles';
import { createHasSessionAccessSelector } from '../session';

export const selectCanAccessStatistics = createHasSessionAccessSelector([ROLE_SUPERADMIN, ROLE_ADMIN]);